import { render, staticRenderFns } from "./Bandwidth.vue?vue&type=template&id=12a5b41b&"
import script from "./Bandwidth.vue?vue&type=script&lang=js&"
export * from "./Bandwidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports